export default __webpack_public_path__ + "static/media/homeimage.25f8af4f.jpg";